import React from 'react';
import { 
  FaUser, 
  FaBirthdayCake, 
  FaMapMarkerAlt, 
  FaLightbulb,
  FaMagic,
  FaShare,
  FaTwitter,
  FaFacebook,
  FaCopy,
  FaDownload,
  FaVolumeUp,
  FaVolumeMute,
  FaTrophy,
  FaChartLine,
  FaStar,
  FaAward,
  FaCalendar,
  FaFlag,
  FaRobot,
  FaTachometerAlt,
  FaChartBar,
  FaCube,
  FaUsers,
  FaRedoAlt,
  FaBrain,
  FaQuoteLeft,
  FaCheckCircle,
  FaExclamationTriangle,
  FaBullseye,
  FaPlay,
  FaCamera,
  FaStop,
  FaExclamationCircle,
  FaBolt,
  FaCog,
  FaMusic,
  FaVolumeDown,
  FaFileAlt,
  FaFileDownload,
  FaLink,
  FaLinkedin,
  FaSignal,
  FaFire,
  FaGraduationCap,
  FaBook,
  FaHammer,
  FaComments,
  FaCheck,
  FaProjectDiagram,
  FaClock,
  FaHeart
} from 'react-icons/fa';

// Icon mapping
const iconComponents = {
  user: FaUser,
  age: FaBirthdayCake,
  location: FaMapMarkerAlt,
  dream: FaLightbulb,
  magic: FaMagic,
  share: FaShare,
  twitter: FaTwitter,
  facebook: FaFacebook,
  copy: FaCopy,
  download: FaDownload,
  volumeUp: FaVolumeUp,
  volumeMute: FaVolumeMute,
  trophy: FaTrophy,
  trend: FaChartLine,
  star: FaStar,
  award: FaAward,
  calendar: FaCalendar,
  flag: FaFlag,
  smartToy: FaRobot,
  dashboard: FaTachometerAlt,
  analytics: FaChartBar,
  viewInAr: FaCube,
  groups: FaUsers,
  refresh: FaRedoAlt,
  psychology: FaBrain,
  lightbulb: FaLightbulb,
  format_quote: FaQuoteLeft,
  check: FaCheckCircle,
  warning: FaExclamationTriangle,
  target: FaBullseye,
  '3d': FaCube,
  play: FaPlay,
  camera: FaCamera,
  stop: FaStop,
  error: FaExclamationCircle,
  impact: FaBolt,
  settings: FaCog,
  music: FaMusic,
  sfx: FaVolumeDown,
  ambient: FaVolumeDown,
  description: FaFileAlt,
  getApp: FaFileDownload,
  link: FaLink,
  linkedin: FaLinkedin,
  signal: FaSignal,
  school: FaGraduationCap,
  library: FaBook,
  build: FaHammer,
  favorite: FaHeart,
  trend_up: FaChartLine,
  comment: FaComments,
  checkbox: FaCheck,
  flowchart: FaProjectDiagram,
  schedule: FaClock
};

const Icon = ({ name, size = 20, className = "", ...props }) => {
  const IconComponent = iconComponents[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  
  return <IconComponent size={size} className={className} {...props} />;
};

export default Icon;